import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { InternshipReportsModel } from 'common/models/page-models/reports/internship-reports-model/internship-reports-data-model';
import { InternshipReportsListingModel } from 'common/models/page-models/reports/internship-reports-model/internship-reports-grid-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { InternshipReportsWidgetService } from 'common/widget/reports/internship-reports.widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class InternshipReportsResolver extends GridResolver<InternshipReportsModel, InternshipReportsListingModel> {
    constructor(
        protected fs: InternshipReportsWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    override modifyResponseData(dataModel: any, meta: any, widget: any) {
        dataModel['filterData'] = new InternshipReportsModel();
        return dataModel;
    }
}